import { getSupportedLanguage, type LanguageLike, SupportedLanguage } from "@warpme/i18n"
import { SupportedLanguage as GraphqlSupportedLanguage } from "@/graphql/graphql"

export { SupportedLanguage }

export const getCurrentLanguage = (languageLike: LanguageLike) => getSupportedLanguage(languageLike)

export const getCurrentFirebaseAuthLanguageCode = (languageLike: LanguageLike): string => {
  switch (getCurrentLanguage(languageLike)) {
    case SupportedLanguage.Ja:
      return "ja"
    case SupportedLanguage.ZhHans:
      return "zh-CN"
    case SupportedLanguage.ZhHant:
      return "zh-TW"
    case SupportedLanguage.Ko:
      return "ko"
    default:
      return "en"
  }
}

export const getCurrentGraphqlLanguage = (languageLike: LanguageLike): GraphqlSupportedLanguage => {
  switch (getCurrentLanguage(languageLike)) {
    case SupportedLanguage.Ja:
      return GraphqlSupportedLanguage.Ja
    case SupportedLanguage.ZhHans:
      return GraphqlSupportedLanguage.ZhHans
    case SupportedLanguage.ZhHant:
      return GraphqlSupportedLanguage.ZhHant
    case SupportedLanguage.Ko:
      return GraphqlSupportedLanguage.Ko
    default:
      return GraphqlSupportedLanguage.En
  }
}
